import React, { useState, useEffect, useContext } from "react";
import { collection, getDocs, query } from "firebase/firestore";
import { db } from "../../../firebase";
import { AuthContext } from "../../../context/AuthContext";
import { uploadErrorLogToFirestore } from "../../../utils/logUtils";
import {
  FormControl,
  InputLabel,
  Select,
  MenuItem
} from '@mui/material';

/**
 * Componente para seleccionar empresas en formularios
 * Versión simplificada sin opción de crear nuevas empresas
 */
const EmpresaComponent = ({ selectedEmpresa, setSelectedEmpresa, onEmpresaChange }) => {
  const [empresas, setEmpresas] = useState([]);
  const [loading, setLoading] = useState(false);
  const { currentService } = useContext(AuthContext);

  // Cargar empresas al iniciar el componente
  useEffect(() => {
    fetchEmpresas();
  }, [currentService]);

  // Obtener las empresas desde Firestore
  const fetchEmpresas = async () => {
    if (!currentService) return;

    try {
      setLoading(true);
      const empresasRef = collection(db, 'servicios', currentService.id, 'empresas');
      const empresasSnap = await getDocs(query(empresasRef));
      const empresasData = empresasSnap.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
      }));
      setEmpresas(empresasData);
      setLoading(false);
    } catch (error) {
      console.error("Error al cargar empresas:", error);
      uploadErrorLogToFirestore(error);
      setLoading(false);
    }
  };

  // Manejar la selección de empresa
  const handleEmpresaChange = (e) => {
    const empresaId = e.target.value;
    setSelectedEmpresa(empresaId);

    // Si hay una función callback externa, la llamamos con los datos completos
    if (onEmpresaChange && empresaId) {
      const empresaSeleccionada = empresas.find(emp => emp.id === empresaId);
      onEmpresaChange({
        empresaId: empresaId,
        empresaNombre: empresaSeleccionada?.nombre || '',
        codEmpresa: empresaSeleccionada?.codEmpresa || ''
      });
    }
  };

  return (
    <FormControl sx={{ minWidth: 300 }} fullWidth>
      <InputLabel id="empresa-label">Empresa</InputLabel>
      <Select
        labelId="empresa-label"
        id="empresa"
        name="empresa"
        value={selectedEmpresa}
        onChange={handleEmpresaChange}
        label="Empresa"
        disabled={loading}
      >
        {empresas.map((empresa) => (
          <MenuItem key={empresa.id} value={empresa.id}>
            {empresa.codEmpresa ? `[${empresa.codEmpresa}] ` : ''}{empresa.nombre}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default EmpresaComponent;